<app-button [class]="class" [buttonSize]="size" class="circle px-1 flex items-center" [buttonType]="buttonType">
  <span class="plus-btn" [class]="size">
    @if (!loadingValue) {
      <app-icon [class]="class" [height]="height" [width]="width" [icon]="icon"></app-icon>
    } @else {
      <app-button-loader></app-button-loader>
    }
  </span>
</app-button>

